var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3429 4.72629C11.2222 3.69577 9.75524 3.12383 8.23274 3.12378C7.42689 3.12462 6.62917 3.28481 5.88547 3.59514C5.14178 3.90547 4.4668 4.35981 3.89937 4.93201C1.47914 7.36252 1.48017 11.1641 3.90142 13.5844L11.4429 21.1258C11.6178 21.4334 11.9551 21.6319 12.3429 21.6319C12.5021 21.6303 12.6588 21.5915 12.8003 21.5184C12.9417 21.4454 13.0641 21.3401 13.1575 21.2112L20.7844 13.5844C23.2057 11.1631 23.2057 7.36252 20.7823 4.92789C20.2152 4.35675 19.5408 3.90333 18.7978 3.59372C18.0548 3.2841 17.258 3.1244 16.4531 3.12378C14.9306 3.12403 13.4638 3.69595 12.3429 4.72629ZM19.3279 6.38229C20.9356 7.99818 20.9366 10.5223 19.33 12.13L12.3429 19.117L5.35582 12.13C3.7492 10.5223 3.75022 7.99818 5.35377 6.38641C6.13548 5.60881 7.15788 5.18092 8.23274 5.18092C9.3076 5.18092 10.3259 5.60881 11.1014 6.38435L11.6157 6.89864C11.7112 6.99424 11.8245 7.07008 11.9493 7.12183C12.0741 7.17358 12.2078 7.20022 12.3429 7.20022C12.478 7.20022 12.6118 7.17358 12.7365 7.12183C12.8613 7.07008 12.9747 6.99424 13.0701 6.89864L13.5844 6.38435C15.1396 4.83224 17.7748 4.83635 19.3279 6.38229Z",
    fill: "#E53935"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4L12.5 6L7.5 4L4.5 5.5L2.5 10.5L12.5 20.5L17.5 15.5L20.5 11.5L21.5 8.5L19.5 5.5L16 4Z",
    fill: "#E53935"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullHeartIcon);
export default __webpack_public_path__ + "static/media/full-heart-icon.c15fd7af1cb7ffcbe95ad269dc270f12.svg";
export { ForwardRef as ReactComponent };